import { jsx as _jsx } from "react/jsx-runtime";
const variantStyles = {
    primary: {
        background: 'var(--fm-gradient-brand)',
        color: 'var(--fm-color-on-primary)',
        border: '1px solid color-mix(in srgb, var(--fm-color-secondary) 40%, transparent)',
    },
    secondary: {
        background: 'var(--fm-color-primary)',
        color: 'var(--fm-color-on-primary)',
        border: 'none',
    },
    ghost: {
        background: 'transparent',
        color: 'var(--fm-color-text)',
        border: '1px solid var(--fm-hairline-strong, var(--fm-color-border))',
    },
    tip: {
        background: '#C9A227',
        color: '#1A1408',
        border: 'none',
    },
    tipMenu: {
        background: '#A67C00',
        color: '#FFF8E7',
        border: 'none',
    },
    games: {
        background: 'var(--fm-color-accent)',
        color: 'var(--fm-color-dark, #0D0D0D)',
        border: 'none',
    },
    toys: {
        background: 'color-mix(in srgb, var(--fm-color-secondary) 55%, var(--fm-color-primary))',
        color: 'var(--fm-color-on-primary)',
        border: 'none',
    },
    request: {
        background: '#C62828',
        color: '#fff',
        border: 'none',
    },
    chip: {
        background: '#E0C56A',
        color: '#1A1408',
        border: '1px solid color-mix(in srgb, #C9A227 45%, transparent)',
    },
};
export function Button({ label, variant = 'primary', onClick, type = 'button', disabled = false, }) {
    return (_jsx("button", { type: type, onClick: onClick, disabled: disabled, style: {
            ...variantStyles[variant],
            fontFamily: 'var(--fm-font-body)',
            padding: '0.625rem 1.25rem',
            borderRadius: 'var(--fm-radius-sm, 4px)',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.6 : 1,
            fontWeight: 600,
            letterSpacing: '0.02em',
            transition: 'filter 0.15s ease, transform 0.15s ease',
        }, children: label }));
}
//# sourceMappingURL=Button.js.map